import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { HomeBannerComponent } from './components/home-banner/home-banner.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { HomeServicesComponent } from './components/home-services/home-services.component';
import { HomeTopcategoriesComponent } from './components/home-topcategories/home-topcategories.component';
import { HomePopularproductsComponent } from './components/home-popularproducts/home-popularproducts.component';
import { HomeCarouselslidestepComponent } from './components/home-carouselslidestep/home-carouselslidestep.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeDesigntemplateComponent } from './components/home-designtemplate/home-designtemplate.component';
import { HomeSliderbannerComponent } from './components/home-sliderbanner/home-sliderbanner.component';
import { HomeFeaturedbrandsComponent } from './components/home-featuredbrands/home-featuredbrands.component';
import { HomeSubscribeComponent } from './components/home-subscribe/home-subscribe.component';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from "src/app/app-routing.module";
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { HomeDesignproductsComponent } from './components/home-designproducts/home-designproducts.component';

@NgModule({
  declarations: [
    HomeComponent,
    HomeBannerComponent,
    HomeServicesComponent,
    HomeTopcategoriesComponent,
    HomePopularproductsComponent,
    HomeDesignproductsComponent,
    HomeCarouselslidestepComponent,
    HomeDesigntemplateComponent,
    HomeSliderbannerComponent,
    HomeFeaturedbrandsComponent,
    HomeSubscribeComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    SharedModule
  ],
  
  exports: [
    HomeComponent,
  ]
})
export class HomeModule {}
